import React, { useState, useEffect } from 'react'
import { Button, Col, Space, Breadcrumb, Form } from 'antd'
import {
  errorNotification,
  successNotification,
  carMakesUrl,
  carModelsUrl,
  bodyTypesUrl,
  fuelTypesUrl,
  transmissionsUrl,
  driveTrainsUrl,
  carSpecsUrl,
  originsUrl,
  conditionsUrl,
  statusesUrl,
  currenciesUrl,
  getRequest,
  carsUrl,
  postRequest
} from '../../config'
import BasicInput from '../../components/Forms/BasicInput'
import TextAreaInput from '../../components/Forms/TextAreaInput'
import SelectInput from '../../components/Forms/SelectInput'
import WithData from 'hocs/WithData'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { KM, MILEAGE_UNITS } from 'app-constants'
import PageTitle from 'components/PageTitle'

const CarForm = props => {
  const [payload, setPayload] = useState({
    make: [],
    model: [],
    trim: '',
    chassisNo: '',
    year: '',
    bodyType: '',
    fuelType: '',
    transmission: '',
    driveTrain: '',
    specs: [],
    engineSize: '',
    engineCylinders: '',
    engineHorsepower: 0,
    engineDescription: '',
    mileage: 0,
    mileageUnit: KM,
    exteriorColor: '',
    interiorColor: '',
    noOfDoors: 0,
    passengers: 0,
    origin: '',
    condition: '',
    status: '',
    sourceCurrency: '',
    sourcePrice: 0,
    additionalCharge: 0,
    additionalChargeCurrency: null,
    profit: 0,
    profitCurrency: 'GHS',
    discount: 0,
    sourceUrl: '',
    msrp: 0
    // customsDutyAmount: '',
    // customsDutyCurrency: '',
    // portChargesAmount: '',
    // portChargesCurrency: ''
  })

  const getYears = () => {
    const years = []
    for (let i = new Date().getFullYear() + 1; i >= 1960; i--) {
      years.push({
        value: i,
        label: i
      })
    }
    return years
  }

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [makes, setMakes] = useState([])
  const [models, setModels] = useState([])
  const [bodyTypes, setBodyTypes] = useState([])
  const [fuelTypes, setFuelTypes] = useState([])
  const [transmissions, setTransmissions] = useState([])
  const [driveTrains, setDriveTrains] = useState([])
  const [origins, setOrigins] = useState([])
  const [conditions, setConditions] = useState([])
  const [statuses, setStatuses] = useState([])
  const [currencies, setCurrencies] = useState([])
  const [specs, setSpecs] = useState([])

  const [catLoading, setCatLoading] = useState(false)

  const getCarsMakes = async () => {
    const response = await getRequest(
      `${carMakesUrl}/all`,
      'makes',
      setCatLoading
    )
    if (response.success) {
      setMakes(
        response.data.map(make => {
          return {
            value: make.id,
            label: make.name
          }
        })
      )
    } else {
      console.log('RESPONSE: ', response)
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getCarsModels = async make => {
    const response = await postRequest(
      `${carModelsUrl}/for-make`,
      { make },
      'models',
      setCatLoading
    )
    if (response.success) {
      setModels(
        response.data.map(model => {
          return {
            value: model.id,
            label: model.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getBodyTypes = async () => {
    const response = await getRequest(
      `${bodyTypesUrl}/all`,
      'bodyTypes',
      setCatLoading
    )
    if (response.success) {
      setBodyTypes(
        response.data.map(bodyType => {
          return {
            value: bodyType.id,
            label: bodyType.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getFuelTypes = async () => {
    const response = await getRequest(
      `${fuelTypesUrl}/all`,
      'fuelTypes',
      setCatLoading
    )
    if (response.success) {
      setFuelTypes(
        response.data.map(fuelType => {
          return {
            value: fuelType.id,
            label: fuelType.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getTransmissions = async () => {
    const response = await getRequest(
      `${transmissionsUrl}/all`,
      'transmissions',
      setCatLoading
    )
    if (response.success) {
      setTransmissions(
        response.data.map(transmission => {
          return {
            value: transmission.id,
            label: transmission.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getDriveTrains = async () => {
    const response = await getRequest(
      `${driveTrainsUrl}/all`,
      'driveTrains',
      setCatLoading
    )
    if (response.success) {
      setDriveTrains(
        response.data.map(driveTrain => {
          return {
            value: driveTrain.id,
            label: driveTrain.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getOrigins = async () => {
    const response = await getRequest(
      `${originsUrl}/all`,
      'origins',
      setCatLoading
    )
    if (response.success) {
      setOrigins(
        response.data.map(origin => {
          return {
            value: origin.id,
            label: origin.country
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getConditions = async () => {
    const response = await getRequest(
      `${conditionsUrl}/all`,
      'conditions',
      setCatLoading
    )
    if (response.success) {
      setConditions(
        response.data.map(condition => {
          return {
            value: condition.id,
            label: condition.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getStatuses = async () => {
    const response = await getRequest(
      `${statusesUrl}/all`,
      'statuses',
      setCatLoading
    )
    if (response.success) {
      setStatuses(
        response.data.map(status => {
          return {
            value: status.id,
            label: status.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getCurrencies = async () => {
    const response = await getRequest(
      `${currenciesUrl}/all`,
      'currencies',
      setCatLoading
    )
    if (response.success) {
      setCurrencies(
        response.data.map(currency => {
          return {
            value: currency.id,
            label: currency.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getSpecs = async () => {
    const response = await getRequest(
      `${carSpecsUrl}/all`,
      'specs',
      setCatLoading
    )
    if (response.success) {
      setSpecs(
        response.data.map(spec => {
          return {
            value: spec.id,
            label: spec.name
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleCreate = async event => {
    event.preventDefault()

    if (payload.make.length === 0 || payload.model.length === 0) {
      errorNotification('Make and Model are required')
      return
    }

    const response = await postRequest(
      carsUrl,
      {
        ...payload,
        make: payload.make[0],
        model: payload.model[0]
      },
      'car',
      setLoading
    )

    if (response.success) {
      // eslint-disable-next-line react/prop-types
      props.history.push(`/cars/${response.data.id}`)
      successNotification('New Car Added')
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  useEffect(() => {
    getCarsMakes()
    getFuelTypes()
    getBodyTypes()
    getTransmissions()
    getDriveTrains()
    getOrigins()
    getConditions()
    getStatuses()
    getCurrencies()
    getSpecs()
    // return () => {
    //   cleanup
    // }
  }, [])

  const { make } = payload

  useEffect(() => {
    if (make.length > 0) getCarsModels(make[0])
  }, [make])

  return (
    <div className="container">
      <PageTitle title="Car form" />
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/cars">Cars</Breadcrumb.Item>
            <Breadcrumb.Item>New Car</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">Add New Car</div>
            <div className="card-body">
              <Form className="p-2rem" layout="vertical">
                <div
                  className="row"
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }}
                >
                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Car Make"
                      name="make"
                      value={payload.make}
                      onChange={handleSelect('make')}
                      optionList={makes}
                      required={true}
                      mode="multiple"
                      loading={catLoading}
                    />
                    {serverErrors.make &&
                      serverErrors.make.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Car Model"
                      name="model"
                      value={payload.model}
                      onChange={handleSelect('model')}
                      optionList={models}
                      required={true}
                      mode="multiple"
                    />
                    {serverErrors.model &&
                      serverErrors.model.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Car Trim"
                      value={payload.trim}
                      name={'trim'}
                      placeholder="trim"
                      handleChange={handleInputChange('trim')}
                      required={true}
                    />
                    {serverErrors.trim &&
                      serverErrors.trim.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Chassis Number"
                      value={payload.chassisNo}
                      name={'chassis number'}
                      placeholder="chassis number"
                      handleChange={handleInputChange('chassisNo')}
                      required={false}
                    />
                    {serverErrors.chassisNo &&
                      serverErrors.chassisNo.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Year Manufactured"
                      name="year"
                      value={payload.year}
                      onChange={handleSelect('year')}
                      optionList={getYears()}
                      required={true}
                    />
                    {serverErrors.year &&
                      serverErrors.year.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="MSRP"
                      value={payload.msrp}
                      name={'msrp'}
                      placeholder="msrp"
                      handleChange={handleInputChange('msrp')}
                      required={true}
                    />
                    {serverErrors.msrp &&
                      serverErrors.msrp.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Body Type"
                      name="bodyType"
                      value={payload.bodyType}
                      onChange={handleSelect('bodyType')}
                      optionList={bodyTypes}
                      required={true}
                    />
                    {serverErrors.bodyType &&
                      serverErrors.bodyType.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Fuel Type"
                      name="fuelType"
                      value={payload.fuelType}
                      onChange={handleSelect('fuelType')}
                      optionList={fuelTypes}
                      required={true}
                    />
                    {serverErrors.fuelType &&
                      serverErrors.fuelType.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Transmission type"
                      name="transmission"
                      value={payload.transmission}
                      onChange={handleSelect('transmission')}
                      optionList={transmissions}
                      required={true}
                    />
                    {serverErrors.transmission &&
                      serverErrors.transmission.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="DriveTrains"
                      name="driveTrain"
                      value={payload.driveTrain}
                      onChange={handleSelect('driveTrain')}
                      optionList={driveTrains}
                      required={true}
                    />
                    {serverErrors.driveTrain &&
                      serverErrors.driveTrain.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Car Specs"
                      name="specs"
                      value={payload.specs}
                      onChange={handleSelect('specs')}
                      optionList={specs}
                      mode="multiple"
                      required={true}
                    />
                    {serverErrors.specs &&
                      serverErrors.specs.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Engine Size (eg: 2.0)"
                      value={payload.engineSize}
                      name={'engineSize'}
                      placeholder="engineSize"
                      handleChange={handleInputChange('engineSize')}
                      required={true}
                    />

                    {serverErrors.engineSize &&
                      serverErrors.engineSize.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Engine Cylinders (eg: 4)"
                      value={payload.engineCylinders}
                      name={'engineCylinders'}
                      placeholder="engineCylinders"
                      handleChange={handleInputChange('engineCylinders')}
                      required={true}
                    />

                    {serverErrors.engineCylinders &&
                      serverErrors.engineCylinders.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Engine Horsepower (eg: 189)"
                      value={payload.engineHorsepower}
                      name={'engineHorsepower'}
                      placeholder="engineHorsepower"
                      handleChange={handleInputChange('engineHorsepower')}
                      required={true}
                    />

                    {serverErrors.engineHorsepower &&
                      serverErrors.engineHorsepower.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <TextAreaInput
                      label="Engine Description (eg: V6 Bi-Turbo)"
                      value={payload.engineDescription}
                      name={'engineDescription'}
                      placeholder="engineDescription"
                      handleChange={handleInputChange('engineDescription')}
                      required={false}
                    />

                    {serverErrors.engineDescription &&
                      serverErrors.engineDescription.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Mileage (eg: 3456)"
                      value={payload.mileage}
                      name={'mileage'}
                      placeholder="mileage"
                      handleChange={handleInputChange('mileage')}
                      required={true}
                    />

                    {serverErrors.mileage &&
                      serverErrors.mileage.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Mileage Unit"
                      name="mileageUnit"
                      value={payload.mileageUnit}
                      onChange={handleSelect('mileageUnit')}
                      optionList={MILEAGE_UNITS}
                      required={true}
                    />
                    {serverErrors.mileageUnit &&
                      serverErrors.mileageUnit.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Exterior Color"
                      value={payload.exteriorColor}
                      name={'exteriorColor'}
                      placeholder="exteriorColor"
                      handleChange={handleInputChange('exteriorColor')}
                      required={true}
                    />

                    {serverErrors.exteriorColor &&
                      serverErrors.exteriorColor.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Interior Color"
                      value={payload.interiorColor}
                      name={'interiorColor'}
                      placeholder="interiorColor"
                      handleChange={handleInputChange('interiorColor')}
                      required={true}
                    />

                    {serverErrors.interiorColor &&
                      serverErrors.interiorColor.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="No. of Doors (eg: 4)"
                      value={payload.noOfDoors}
                      name={'doors'}
                      placeholder="doors"
                      handleChange={handleInputChange('noOfDoors')}
                      required={true}
                    />

                    {serverErrors.noOfDoors &&
                      serverErrors.noOfDoors.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="No. of Seats (eg: 4)"
                      value={payload.passengers}
                      name={'passengers'}
                      placeholder="passengers"
                      handleChange={handleInputChange('passengers')}
                      required={true}
                    />

                    {serverErrors.passengers &&
                      serverErrors.passengers.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Country of Origin"
                      name="origin"
                      value={payload.origin}
                      onChange={handleSelect('origin')}
                      optionList={origins}
                      required={true}
                    />
                    {serverErrors.origin &&
                      serverErrors.origin.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Condition"
                      name="condition"
                      value={payload.condition}
                      onChange={handleSelect('condition')}
                      optionList={conditions}
                      required={true}
                    />
                    {serverErrors.condition &&
                      serverErrors.condition.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <TextAreaInput
                      label="Car Source Url"
                      value={payload.sourceUrl}
                      name={'sourceUrl'}
                      placeholder="sourceUrl"
                      handleChange={handleInputChange('sourceUrl')}
                      required={false}
                    />

                    {serverErrors.sourceUrl &&
                      serverErrors.sourceUrl.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Source Price"
                      value={payload.sourcePrice}
                      name={'sourcePrice'}
                      placeholder="sourcePrice"
                      handleChange={handleInputChange('sourcePrice')}
                      required={true}
                    />
                    {serverErrors.sourcePrice &&
                      serverErrors.sourcePrice.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Source Currency"
                      name="sourceCurrency"
                      value={payload.sourceCurrency}
                      onChange={handleSelect('sourceCurrency')}
                      optionList={currencies}
                      required={true}
                    />
                    {serverErrors.sourceCurrency &&
                      serverErrors.sourceCurrency.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Additional Charge"
                      value={payload.additionalCharge}
                      name={'additionalCharge'}
                      placeholder="additionalCharge"
                      handleChange={handleInputChange('additionalCharge')}
                      required={false}
                    />
                    {serverErrors.additionalCharge &&
                      serverErrors.additionalCharge.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Additional Charge Currency"
                      name="additionalChargeCurrency"
                      value={payload.additionalChargeCurrency}
                      onChange={handleSelect('additionalChargeCurrency')}
                      optionList={currencies}
                      required={false}
                    />
                    {serverErrors.additionalChargeCurrency &&
                      serverErrors.additionalChargeCurrency.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <BasicInput
                      label="Profit"
                      value={payload.profit}
                      name={'profit'}
                      placeholder="profit"
                      handleChange={handleInputChange('profit')}
                      required={true}
                    />
                    {serverErrors.profit &&
                      serverErrors.profit.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Profit Currency"
                      name="profitCurrency"
                      value={payload.profitCurrency}
                      onChange={handleSelect('profitCurrency')}
                      optionList={[{ value: 'GHS', label: 'GHS' }]}
                      required={true}
                    />
                    {serverErrors.profitCurrency &&
                      serverErrors.profitCurrency.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {/* <div className="col-md-5">
                    <BasicInput
                      label="Customs Duty Amount"
                      value={payload.customsDutyAmount}
                      name={'customsDutyAmount'}
                      placeholder="customs duty amount"
                      handleChange={handleInputChange('customsDutyAmount')}
                      required={true}
                    />
                    {serverErrors.customsDutyAmount &&
                      serverErrors.customsDutyAmount.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div> */}

                  {/* <div className="col-md-5">
                    <SelectInput
                      label="Customs Duty Currency"
                      value={payload.customsDutyCurrency}
                      name={'customsDutyCurrency'}
                      placeholder="customs duty currency"
                      onChange={handleSelect('customsDutyCurrency')}
                      optionList={currencies}
                      required={payload.customsDutyAmount ? true : false}
                    />
                    {serverErrors.customsDutyCurrency &&
                      serverErrors.customsDutyCurrency.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div> */}

                  {/* <div className="col-md-5">
                    <BasicInput
                      label="Port Charges Amount"
                      value={payload.portChargesAmount}
                      name={'portChargesAmount'}
                      placeholder="port charges amount"
                      handleChange={handleInputChange('portChargesAmount')}
                      required={payload.customsDutyAmount ? true : false}
                    />
                    {serverErrors.portChargesAmount &&
                      serverErrors.portChargesAmount.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div> */}

                  {/* <div className="col-md-5">
                    <SelectInput
                      label="Port Charges Currency"
                      value={payload.portChargesCurrency}
                      name={'portChargesCurrency'}
                      placeholder="port charges currency"
                      onChange={handleSelect('portChargesCurrency')}
                      optionList={currencies}
                      required={payload.portChargesAmount ? true : false}
                    />
                    {serverErrors.portChargesCurrency &&
                      serverErrors.portChargesCurrency.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div> */}

                  <div className="col-md-5">
                    <SelectInput
                      placeholder="select"
                      label="Status"
                      name="status"
                      value={payload.status}
                      onChange={handleSelect('status')}
                      optionList={statuses}
                      required={true}
                    />
                    {serverErrors.status &&
                      serverErrors.status.map((err, i) => (
                        <div className="text-danger" key={i}>
                          {err}
                        </div>
                      ))}
                  </div>

                  {serverErrors.nonFieldErrors &&
                    serverErrors.nonFieldErrors.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}

                  <Col md={24}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        marginBottom: '20px'
                      }}
                    >
                      <Space>
                        {/* eslint-disable-next-line react/prop-types */}
                        <Button onClick={() => props.history.goBack()}>
                          Go Back
                        </Button>
                        <Button
                          type="primary"
                          onClick={handleCreate}
                          loading={loading}
                        >
                          Submit
                        </Button>
                      </Space>
                    </div>
                  </Col>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WithData(withRouter(CarForm))
